// Dark-safe interpretation of the per-question drill-down GET response.
// doGetCall resolves the data object on 200, or { status, errMsg } on non-200
// (and a raw Error on a network reject). The drill-down is master-flag gated, so a
// 404 means "not enabled" — the caller should show a dark state, never an error.
export function drilldownResult(res) {
  if (res && res.status === 404) {
    return { state: "dark" };
  }
  // Non-200 error object, a network reject (Error, no questionId), or an unexpected
  // shape → a real error. A valid payload always carries the echoed questionId.
  if (!res || res.status || typeof res !== "object" || !("questionId" in res)) {
    return { state: "error" };
  }
  return { state: "ok", data: res };
}

// Dark-safe interpretation of the operator-analytics GET response. Same shape as
// the drill-down: 404 (flag off) → dark, other non-200/reject/unexpected → error,
// valid payload → ok. A valid analytics payload always carries queueHealth.
export function analyticsResult(res) {
  if (res && res.status === 404) {
    return { state: "dark" };
  }
  if (!res || res.status || typeof res !== "object" || !("queueHealth" in res)) {
    return { state: "error" };
  }
  return { state: "ok", data: res };
}

// Dark-safe interpretation of the correction-console export response. Same shape:
// 404 (flag off) → dark, other non-200/reject/unexpected → error, valid → ok.
// A valid export payload always carries an entries array.
export function exportResult(res) {
  if (res && res.status === 404) {
    return { state: "dark" };
  }
  if (!res || res.status || typeof res !== "object" || !Array.isArray(res.entries)) {
    return { state: "error" };
  }
  return { state: "ok", data: res };
}
